import apiClient from '../../config/axios';

export const stripeCoursePaymentService = {
  /**
   * Crea una sessione di pagamento Stripe per l'iscrizione al corso
   * @param {Object} courseData - I dati del corso
   * @returns {Promise<Object>} - Risposta con sessionId e checkoutUrl
   */
  createPaymentSession: async (courseData) => {
    try {
      
      
      const response = await apiClient.post('/api/enrollments/create-payment-session-new-course', {
        courseData: courseData,
      });
      return {
        success: true,
        sessionId: response.data.sessionId,
        checkoutUrl: response.data.checkoutUrl,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Errore nella creazione della sessione di pagamento',
      };
    }
  },

  /**
   * Gestisce il ritorno da Stripe checkout
   * @param {string} sessionId - Stripe session ID
   * @param {string} paymentStatus - Stato del pagamento da Stripe
   * @returns {Object} - Stato e messaggio di errore
   */
  handlePaymentReturn: (sessionId, paymentStatus) => {
    if (paymentStatus === 'success') {
      return {
        success: true,
        message: 'Pagamento completato con successo',
      };
    } else {
      return {
        success: false,
        error: 'Pagamento annullato o fallito',
      };
    }
  },

  /**
   * Reindirizza a Stripe checkout
   * @param {string} checkoutUrl - URL di Stripe checkout
   */
  redirectToCheckout: (checkoutUrl) => {
    window.location.href = checkoutUrl;
  },
}; 